import { Link } from "react-router-dom";
import { Star, Quote, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, Reveal } from "@/components/Primitives";
import { TESTIMONIALS } from "@/data/site";

const MORE = [
  { name: "Amanda R.", location: "Plano", quote: "I was nervous leaving my newborn, but our overnight caregiver was so calm and experienced. I finally slept through the night.", rating: 5 },
  { name: "The Nguyen Family", location: "Frisco", quote: "We've had the same weekly sitter for two years now. She's part of our family. This agency is simply the best in DFW.", rating: 5 },
  { name: "Rebecca T.", location: "Colleyville", quote: "Booked a sitter for a hotel stay during a conference. Professional, punctual, and my kids had a blast.", rating: 5 },
  { name: "David & Kate", location: "University Park", quote: "The 11-step screening gave us total peace of mind. You can feel the difference in the caliber of their caregivers.", rating: 5 },
];

export default function Reviews() {
  const all = [...TESTIMONIALS, ...MORE];
  return (
    <>
      <Seo
        title="Reviews"
        description="Read what DFW families say about Mom's Best Friend Sitters — trusted babysitting, event and overnight care backed by 30+ years and an 11-step screening."
        breadcrumbs={[{ name: "Home", item: "/" }, { name: "Reviews", item: "/reviews" }]}
      />
      <PageHero
        overline="What families say"
        title="Loved by DFW families for generations"
        subtitle="Real words from the parents who trust us with what matters most. (Curated reviews — Google reviews integration coming soon.)"
      >
        <div className="flex items-center gap-3">
          <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" />)}</div>
          <span className="text-sm font-semibold text-espresso">5.0 average · Trusted since 1994</span>
        </div>
      </PageHero>

      <section className="container-mbf py-20 md:py-28">
        <div className="columns-1 md:columns-2 lg:columns-2 gap-6 space-y-6">
          {all.map((t, i) => (
            <Reveal key={i} delay={(i % 4) * 0.05}>
              <figure className="card-warm p-8 break-inside-avoid" data-testid={`review-card-${i}`}>
                <div className="flex gap-1 mb-4">{[...Array(t.rating)].map((_, j) => <Star key={j} className="w-4 h-4 text-gold fill-gold" />)}</div>
                <Quote className="w-6 h-6 text-terracotta/30 mb-2" />
                <blockquote className="text-base leading-relaxed text-espresso font-accent">"{t.quote}"</blockquote>
                <figcaption className="mt-5 text-sm">
                  <span className="font-semibold text-espresso">{t.name}</span>
                  <span className="text-stoneish"> · {t.location}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link to="/book" className="btn-accent !px-8 !py-4" data-testid="reviews-request-cta">Join our families — Request a Sitter <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </>
  );
}
